import { render, staticRenderFns } from "./benefitConfig.vue?vue&type=template&id=73d938a5&"
import script from "./benefitConfig.vue?vue&type=script&lang=js&"
export * from "./benefitConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports